<template>
  <div id="app" :class="{ 'test-environment-style': isNotProduction }">
    <notification-container />
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script setup>
import { computed } from 'vue'

import NotificationContainer from '@/components/NotificationContainer.vue'

const isNotProduction = computed(() => import.meta.env.MODE !== 'production')
</script>

<style scoped>
.test-environment-style {
  margin-top: 20px;
}
</style>
